//src/app/features/dashboard/admin/stats/TaxReturnsStats.tsx
import { useGetTaxReturnStatsQuery } from 'app/services/projects';
import Spinner from 'Components/Spinner';
import InAppTaxReturnStatusStats from './InAppTaxReturnStatusStats copy';
import MondayTaxReturnStatusStats from './MondayTaxReturnStatusStats';
import TaxReturnIndividualBusinessStats from './TaxReturnIndividualBusinessStats';

interface ITaxReturnsStats {
  year: number;
}

const TaxReturnsStats = ({ year }: ITaxReturnsStats) => {
  const { data } = useGetTaxReturnStatsQuery({
    filters: {
      created_at: year,
    },
  });

  if (!data)
    return (
      <div className="h-48 flex justify-center items-center">
        <Spinner />
      </div>
    );

  return (
    <div className="flex flex-wrap w-full">
      <div className="w-full px-4 font-semibold text-sm text-gray-dark">
        Tax Returns ({data.tax_returns_stats.total_tax_returns_count})
      </div>
      <MondayTaxReturnStatusStats data={data} />
      <InAppTaxReturnStatusStats data={data} />
      <TaxReturnIndividualBusinessStats data={data} />
    </div>
  );
};

export default TaxReturnsStats;
